
import { Vue, Component } from 'vue-property-decorator'
import SimpleTable from '@/components/busi/table/simple-table.vue'
import { orderFeesChangeList, orderFeesChangeListCount, orderFeesChangeDetail } from '@/api/ordercenter'
import OrderFeesChangeDetail from './detail/orderfeeschangedetail.vue'
import util from '@/utils/busi/util'

@Component({
  name: 'feeschange',
  components: {
    SimpleTable,
    OrderFeesChangeDetail
  }
})

export default class FeesChange extends Vue {
  private params = util.getRouterParams()

  private tableData = {
    list: [],
    totalCount: 0
  }

  private pagination = {
    currentPage: 1,
    pageSize: 10
  }

  private loading = !1

  private columns = [
    {
      prop: 'userAlias',
      label: '操作账号'
    },
    {
      prop: 'createName',
      label: '操作员'
    },
    {
      prop: 'createTime',
      label: '操作时间',
      format: 'date'
    }
  ]

  beforeMount () {
    this.initData()
  }

  private async initData (pagination: any = null) {
    await orderFeesChangeList({
      signUpId: this.params.id,
      ...pagination || this.pagination
    }).then(async (res: any) => {
      if (res.code === 10000) {
        await orderFeesChangeListCount({
          signUpId: this.params.id
        }).then(async (cntRes: any) => {
          if (res.code === 10000) {
            this.tableData.list = res.object.list || []
            this.tableData.totalCount = cntRes.object.totalCount
          }
        })
      }
    })
  }

  private detailData = {}

  private dialogVisible = !1

  private id = -1

  private rowDbClick (row: any) {
    this.showDetail(row)
  }

  private async showDetail (row: any) {
    console.log(row)
    this.id = row.id
    this.dialogVisible = !0
  }

  private closeDialog () {
    // do
  }
}
